import React from 'react';
import { MainNavigationBar } from '../component/navigation-bar/MainNavigationBar';
import { MainPageLayout } from '../layout/MainPageLayout';
import { GroupTaskDiv } from '../component/group-task/GroupTaskDiv';

export const GroupTaskPage = () => (
  <MainPageLayout
    navigationBar={<MainNavigationBar />}
    elementCentr={<GroupTaskDiv />}
  />
);
